import React from "react";
import "./css/KnittingOrder.css";

function OrderSwitch({
  descending = true,
  rightToLeft = false,
  onChange,
  onDirectionChange,
  flatKnitting = true,
  knittingInTheRound = false,
  onKnittingInTheRoundChange,
}) {
  const handleAscendingChange = () => {
    if (onChange) onChange(false);
  };

  const handleDescendingChange = () => {
    if (onChange) onChange(true);
  };

  const handleLeftToRight = () => {
    if (onDirectionChange) onDirectionChange(false);
  };

  const handleRightToLeft = () => {
    if (onDirectionChange) onDirectionChange(true);
  };

  const handleFlatKnitting = () => {
    if (onKnittingInTheRoundChange) onKnittingInTheRoundChange(false);
    if (onDirectionChange) onDirectionChange(false);
  };

  const handleKnittingInTheRound = () => {
    if (onKnittingInTheRoundChange) onKnittingInTheRoundChange(true);
  };

  return (
    <div className="order-switch">
      <div className="switch-options">
        <section className="options-section">
          <label className="order-option">
            <input
              type="checkbox"
              checked={descending}
              onChange={handleDescendingChange}
            />
            <span>Bottom Up</span>
          </label>

          <label className="order-option">
            <input
              type="checkbox"
              checked={!descending}
              onChange={handleAscendingChange}
            />
            <span>Top Down</span>
          </label>
        </section>

        <section className="options-section">
          <label className="order-option">
            <input
              type="checkbox"
              checked={!rightToLeft}
              onChange={handleLeftToRight}
            />
            <span>Left to Right</span>
          </label>

          <label className="order-option">
            <input
              type="checkbox"
              checked={rightToLeft}
              onChange={handleRightToLeft}
            />
            <span>Right to Left</span>
          </label>
        </section>

        <section className="options-section">
          <label className="order-option">
            <input
              type="checkbox"
              checked={flatKnitting}
              onChange={handleFlatKnitting}
            />
            <span>Flat Knitting</span>
          </label>

          <label className="order-option">
            <input
              type="checkbox"
              checked={knittingInTheRound}
              onChange={handleKnittingInTheRound}
            />
            <span>Knitting in the Round</span>
          </label>
        </section>
      </div>
    </div>
  );
}

export default OrderSwitch;